import { Button } from "@svea/design-system-components-react";
import { useFormContext } from "../form/form-context";

type SubmitButtonProps = {
	label: React.ReactNode;
	isLoading?: boolean;
	iconStart?: "horizontalSlider" | "bankId";
	fullWidth?: boolean;
};

export const SubmitButton = ({
	label,
	isLoading,
	iconStart,
	fullWidth,
	...rest
}: SubmitButtonProps) => {
	const form = useFormContext();
	return (
		<form.Subscribe
			selector={(state) => [state.canSubmit, state.isSubmitting]}
			children={([_canSubmit, isSubmitting]) => (
				<Button
					type="submit"
					isDisabled={isSubmitting}
					isPending={isLoading}
					iconStart={iconStart}
					width={fullWidth ? "full" : "auto"}
					{...rest}
				>
					{label}
				</Button>
			)}
		/>
	);
};
